import React, { useState } from "react";
import Cons from '../../assets/images/consultant.svg';
import { useProductDispatch } from "../../stores/product/product.store";
import { gtag, sendCallEvent } from "../../stores/product/product.reducer";

interface ConsultantProps {
    number: string;
    text: string;
    numberText: string;
}

export const Consultant: React.FC<ConsultantProps> = ({ number, text, numberText }) => {
    const [showNumber, setShowNumber] = useState<boolean>(false);
    const dispatch = useProductDispatch();

    const clickShow = () => {
        if(!showNumber) {
            dispatch(sendCallEvent({ telephone: number, event: 'reveal' }));
        }
        if(!showNumber) setShowNumber(true);
    }

    const formatPhone = (phone: string): string => {
        return `+373 ${phone.slice(1, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
    };

    const call = () => {
        dispatch(sendCallEvent({ telephone: number, event: 'call' }));
        dispatch(gtag('mn_click_call'));
        dispatch(gtag('mn_phone_click'));
    }

    return (
        <div className="bg-[#f7f8fa] p-[16px] md:p-[24px] rounded-2xl">
            {/*<div className="rounded-2xl bg-white cursor-pointer p-4 mb-5">*/ }
            {/*    <p className="font-bold text-center">Написать</p>*/ }
            {/*</div>*/ }
            <div className="flex justify-center mb-5">
                <img width={ 24 } height={ 24 } src={ Cons } alt="consultant"/>
                <p className="ml-3">{ text }</p>
            </div>
            <div className="rounded-2xl bg-white cursor-pointer p-4" onClick={ () => clickShow() }>
                { !showNumber ? <p className="font-bold text-center">{ numberText }</p>
                    :
                    <a onClick={ () => call() } href={ `tel:${ number }` }
                       className="inline-block font-bold text-center w-full">{ formatPhone(number) }</a> }
            </div>
        </div>
    )
}